export enum FiatRampAction {
  Buy = 'buy',
  Sell = 'sell',
}
